import { svg } from "lit";
const icon = svg `<path d="M10.0003 12.823L6.60933 9.43206L7.38335 8.67406L9.45866 10.7494V3.41602H10.542V10.7494L12.6173 8.67406L13.3913 9.43206L10.0003 12.823ZM4.41699 15.5826V12.9833H5.5003V14.4993H14.5003V12.9833H15.5836V15.5826H4.41699Z" fill="currentColor"/>`;
export default icon;
